<template>
  <div>
    <app-header></app-header>
    <app-main></app-main>
  </div>
</template>

<script>
import AppHeader from './AppHeader/index_RC.vue';
import AppMain from './AppMain/index.vue';

export default {
    components: {
        AppHeader,
        AppMain
    }
}
</script>
